import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useOrderBundle'
import { useRelations } from '@hooks/useAgencyOrderBundle'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

import type { AgencyOrderBundleModel } from '@domain-group/realhub-backend-api-types'

interface AgencyOrderBundleListItemProps {
  agencyOrderBundle: AgencyOrderBundleModel,
}

const AgencyOrderBundleListItem = (props: AgencyOrderBundleListItemProps) => {
  const { agencyOrderBundle, ...restProps } = props

  const {
    orderBundle,
    orderBundle: {
      id,
      title,
    },
  } = useRelations(agencyOrderBundle)

  const { editOrderBundleUrl } = generateUrls(orderBundle)

  return (
    <DashboardModuleListItem
      title={title}
      {...restProps}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Actions>
          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.Icon
            href={`${editOrderBundleUrl}?redirect=${generateRedirectUrl()}`}
            type="link"
          />
          {/*
         // @ts-expect-error TS2339 */}
        </DashboardModuleListItem.Actions>
      </ScopedConditionalContent>
    </DashboardModuleListItem>
  )
}

export default AgencyOrderBundleListItem
